"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionServiceClient = void 0;
var SessionServiceClient_1 = require("./SessionServiceClient");
Object.defineProperty(exports, "SessionServiceClient", { enumerable: true, get: function () { return __importDefault(SessionServiceClient_1).default; } });
//# sourceMappingURL=index.js.map